jQuery(function($) {

  var l_window = parseInt($(window).width());
  var header = $('#masthead'); 

     /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
    if(l_window > 1023){
      action_on_scroll();
    }
    });

   /* menu mobile - add */
  $( "#primary-menu > li.menu-item-has-children" ).each(function( index ) {
     var $link_txt =  $( this ).find('> a').text();
     $( this ).children('ul.sub-menu').prepend('<li class="title_sub_menu_back"><i class="icon-prev"></i>'+$link_txt+'</li>');
    
  }); 

  
  $( ".menu-toggle" ).click(function() {
    $('#primary-menu > li.menu-item-has-children').removeClass('focus');
  });

  $( ".title_sub_menu_back" ).click(function() {
    $(this).parent().parent().removeClass('focus');
  });


  function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }


  /*****************************************************/
    /*********** SWIPER TOP HOME ************/
  /*****************************************************/
  var swiper_homeTop = new Swiper('.slider-hometop-js', {
  
      spaceBetween: 0, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

       pagination: {
        el: '.swiper-bullet-pagination-home-top',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
    
    });



    $(".titlekey").each(function() {
      var count = $(this),
          zero={val:0};
        gsap.to(zero,{delay:count.data("delay"),duration:3,val:count.data("number"),onUpdate:countNumber,ease:Power1.easeOuteaseOut});

        function countNumber() {
          var final = gsap.utils.snap(1, zero.val);
          count.text(final);
        }
  });
  


      /********************************/
  /* ********* SLIDER INVITE PAGE ACCUEIL *******/

   var swiper_Guest_home = new Swiper('.swiper-GuestNow-home', {

     // If we need pagination
       spaceBetween: 20,
       slidesPerView: 1.3,
       loop: true,
       allowTouchMove: true,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },
       breakpoints: {
            1600: { // a partir de 769
              spaceBetween: 100,
              slidesPerView: 3.6,
            },

            1400: { // a partir de 769
              spaceBetween: 50,
              slidesPerView: 3.1,
            },

             1024: { // a partir de 10224
              spaceBetween: 80,
              slidesPerView: 2.6,
            },
            768: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 2.6,
            },
            550: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 1.8,
            },
            425: { // a partir de 10224
              spaceBetween: 40,
              slidesPerView: 1.6,
            }
      
      },
       navigation: {
            nextEl: '.only-guest-next',
            prevEl: '.only-guest-prev'
      },
    
      pagination: {
        el: '.GuestNow-pagination-render',
        type:"fraction",
         renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '/' + '<span class="' + totalClass + '"></span>';
      },

       
    }

   });  
   



  //   // FORM CONTACT LABEL ///

  // $( ".wpcf7-form p.m_move label" ).click(function() {
  //     $( this ).parent().addClass('focus');
  // });

  // $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
  //     $( this ).parent().parent().addClass('focus');
  // });

  //  $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
  //     if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  // });





   // /***************** ANIMATIONS *******************/


   //   const inview = gsap.utils.toArray('.gsap_inview');
   //    inview.forEach((btn) => {
   //      gsap.from(btn, {
   //        scrollTrigger: {
   //          trigger: btn,
   //          start: "top bottom",
   //              end: "center top",
   //          onEnter: function () {
   //              btn.classList.add("to_anim_trigger");
   //          },
   //          onEnterBack: function () {
   //              btn.classList.add("to_anim_trigger");
   //          },
   //          onLeave: function () {
   //              btn.classList.remove("to_anim_trigger");
   //          },
   //          onLeaveBack: function () {
   //              btn.classList.remove("to_anim_trigger");
   //          },

   //        }
   //      });
   //    });


     

    //   /*****************************
    //     Ajout PM MARS 2026
    //   ******************************/



    // /* Block services uniqument sur mobile */
    //  $('.slick_avantages_landing').slick({
    //   arrows: false,
    //   autoplay:true,
    //   autoplaySpeed: 4000,
    //   slidesToScroll: 2,
    //   slidesToShow: 2,
    //   dots:true,
    //   responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //         },
    //       },
    //        {
    //         breakpoint: 500,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         },
    //       }
    //     ]
    // });





     
   ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content').hide();
  
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////
     
    

     $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-120;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });


});


